<template>
    <div>
        <div class="modal fade" id="editCategoryData" tabindex="-1" aria-labelledby="editCategoryDataTitle" style="display: none;" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg two-factor-auth-sms">
              <div class="modal-content">
                <div class="modal-header bg-transparent">
                  <button id="editCategoryDataClose" type="button" class="btn-close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                </div>
                <div class="modal-body pb-5 px-sm-5 mx-50">
                    <form action="javascript:;" class="mt-2" v-on:submit.prevent="editCategory">
                        <div class="row">
                            <div class="col-md-12 col-12">
                              <div class="form-group mb-2">
                                <label for="blog-edit-title">Category Title</label>
                                <b-form-input
                                  id="blog-edit-title"
                                  v-model="categoryTitle"
                                  placeholder="Category Title"
                                />
                              </div>
                            </div>
                              <div class="col-12">
                                <div class="form-group mb-2">
                                    <label>Category Description</label>
                                    <div id="blog-editor-wrapper">
                                        <b-form-textarea
                                        id="textarea-state"
                                        v-model="categoryDecription"
                                        placeholder="Enter at least 10 characters"
                                        rows="3"
                                        ></b-form-textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 mb-2">
                                <div class="border rounded p-2">
                                    <h4 class="mb-1">Featured Image</h4>
                                    <div class="media flex-column flex-md-row">
                                        <img :src="file" id="blog-feature-image preview" class="rounded mr-2 mb-1 mb-md-0" width="170" height="110" alt="Blog Featured Image" v-if="file"/>
                                        <img src="/assets/images/slider/03.jpg" id="blog-feature-image preview" class="rounded mr-2 mb-1 mb-md-0" width="170" height="110" alt="Blog Featured Image" v-else/>

                                        <div class="media-body">
                                            <small class="text-muted">Required image resolution 800x400, image size 10mb.</small>
                                            <p class="my-50">
                                                <a href="javascript:void(0);" id="blog-image-text">C:\fakepath\banner.jpg</a>
                                            </p>
                                            <div class="d-inline-block">
                                                <div class="form-group mb-0">
                                                    <div class="custom-file">
                                                        <input type="file" class="custom-file-input" id="blogCustomFile" accept="image/*" data-toggle="modal" data-target="#larger" @change="selectedImg" enctype="multipart/form-data"/>
                                                        <label class="custom-file-label" for="blogCustomFile">Choose file</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 mt-50 d-flex justify-content-end">
                                <button type="submit" class="btn btn-primary mr-1">Publish Category</button>
                                <button type="reset" class="btn btn-outline-secondary mt-1 me-1 waves-effect mr-1" data-dismiss="modal" aria-label="Close">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
              </div>
            </div>
          </div>
    </div>
    <div class="modal fade text-left show" id="larger" tabindex="-1" aria-labelledby="myModalLabel17" style="padding-right: 15px;" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <cropper
                      v-if='img'
                      class="cropper"
                      :src="img"
                      :stencil-props="{
                        aspectRatio: 1/1
                      }"
                      @change="change"
                    />
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary waves-effect waves-float waves-light" data-dismiss="modal">Accept</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref,computed } from 'vue'
import vSelect from 'vue-select'
import { Cropper } from 'vue-advanced-cropper'
import {BFormInput,BFormTextarea} from 'bootstrap-vue-3'
import 'vue-select/dist/vue-select.css';
import 'vue-advanced-cropper/dist/style.css';

export default {
    name:'EditCategoryKnowledgeBase',
    components: {
        vSelect,BFormInput,Cropper
    },
    props: {
      uuid: {
        type: String,
      },
      method:{
        type:Function
      },
      category:{
        type:Object
      }
    },
    setup(props){
        const categoryTitle = ref(null),
        categoryDecription = ref(null),
        img=ref(null),
        file=ref(null),
        uuid = computed(()=>{
            return props.uuid
        }),
        categoryData = computed(()=>{
            return props.category
        }),
        title = ref(categoryTitle);
        return {
            categoryTitle,
            categoryDecription,
            categoryData,
            title,
            img,
            file,
            uuid
        }
    },
    created(){

    },
    methods:{
        selectedImg(e) {
            e.preventDefault()
            const file = e.target.files[0];
            this.img = URL.createObjectURL(file);
        },
        converter(canvas){
            this.file = canvas.toDataURL();
        },
        change({ coordinates, canvas }) {
            this.converter(canvas)
        },
        clearFields(){
            this.categoryTitle = null;
            this.categoryDecription = null;
            this.file=null;
        },
        getCategory(){
            axios.post(`/admin/knowledge/${this.categoryId}`).then((data)=>{
                if(data){
                    this.categoryData = data.data.data
                    this.categoryTitle = data.data.data.title
                    this.categoryDecription = data.data.data.description
                    this.file = data.data.data.image_url
                }
            });
        },
        editCategory() {
            if(this.uuid != ""){
                var catTitle = this.categoryTitle,
                catdecription = this.categoryDecription,
                file = this.file;
                if(this.file == this.categoryData.image_url){
                    file = ""
                }
                const params = {
                    category_title:catTitle,
                    category_decription:catdecription,
                    image: file
                }
                if(catTitle != "" && catdecription != ""){
                    axios.put(`/admin/knowledge/update/category/${this.uuid}`,params).then(({data})=>{
                        if(data.error == false){
                            toastr.success(data.message, "Success");
                            this.clearFields();
                            this.method();
                        }

                    }).catch((error)=>{
                        return toastr.error('Something went Wrong, Please try again.', "error!");
                    })
                }else{
                    toastr.error('All fields are required!', "error!");
                }

            }


        }
    }
}
</script>
<style>
#video-edit-input{
    background: white;
}
#video-edit-input input{
    height:28px;
    background:white;
}
</style>
